<template>
  <div class="big-container">
    <div class="zh-header">
      <div class="zh-header-left">
        <el-select
          v-model="libraryName"
          placeholder="题库名称"
          style="
            width: 180px;
            border: 1px solid #ededed;
            margin-left: 10px;
            font-size: 14px;
            border-radius: 3px;
          "
          @change="handleSelectChange($event, 1)"
        >
          <el-option
            v-for="item in myLibraryList"
            :key="item.value"
            :label="item.label"
            :value="item"
          >
          </el-option>
        </el-select>
        <div class="hover-content" @click="handleShowDialog(1)">
          <p>规范</p>
          <i class="el-icon-arrow-down" style="color: #c0c4cc"></i>
        </div>
        <div class="hover-content" @click="handleShowDialog(2)">
          <p>范例</p>
          <i class="el-icon-arrow-down" style="color: #c0c4cc"></i>
        </div>
        <el-select
          v-model="downloadValue"
          placeholder="题库名称"
          style="
            width: 180px;
            border: 1px solid #ededed;
            margin-left: 10px;
            font-size: 14px;
            border-radius: 3px;
          "
          @change="handleSelectChange($event, 2)"
        >
          <el-option
            v-for="item in downloadOptions"
            :key="item.value"
            :label="item.label"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="zh-header-right">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handleUploadClick"
        >
          上传文件
        </el-button>
      </div>
    </div>
    <div class="zh-container">
      <div class="zh-container-left">
        <textarea
          v-model="extractedText"
          placeholder="请输入内容"
          style="width: 100%; height: 100%; resize: none"
        ></textarea>
      </div>
      <button class="zh-btn" @click="handleCheck">检查</button>
      <div class="zh-container-right">
        <div class="question-list-container">
          <div
            v-for="(item, index) in questionList"
            :key="item.id"
            class="question-item"
          >
            <div class="item" v-if="item.type == QuestionType.SCQ">
              <div style="position: relative">
                <QuestionPreviewSCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSCQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MCQ">
              <div style="position: relative">
                <QuestionPreviewMCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMCQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DLQ">
              <div style="position: relative">
                <QuestionPreviewDLQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDLQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.VOTE">
              <div style="position: relative">
                <QuestionPreviewVote
                  :params="{ data: item, index: index }"
                ></QuestionPreviewVote>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SORT">
              <div style="position: relative">
                <QuestionPreviewSort
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSort>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SBQ">
              <div style="position: relative">
                <QuestionPreviewSBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSBQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MBQ">
              <div style="position: relative">
                <QuestionPreviewMBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMBQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.QA">
              <div style="position: relative">
                <QuestionPreviewQA
                  :params="{ data: item, index: index }"
                ></QuestionPreviewQA>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NPS">
              <div style="position: relative">
                <QuestionPreviewNPS
                  :params="{ data: item, index: index }"
                ></QuestionPreviewNPS>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.IMAGE">
              <div style="position: relative">
                <QuestionPreviewImage
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImage>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.WRQ">
              <div style="position: relative">
                <QuestionPreviewWRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewWRQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SRQ">
              <div style="position: relative">
                <QuestionPreviewSRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSRQ>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NAME">
              <div style="position: relative">
                <QuestionPreviewName
                  :params="{ data: item, index: index }"
                ></QuestionPreviewName>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.GENDER">
              <div style="position: relative">
                <QuestionPreviewGender
                  :params="{ data: item, index: index }"
                ></QuestionPreviewGender>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.AGE">
              <div style="position: relative">
                <QuestionPreviewAge
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAge>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TEL">
              <div style="position: relative">
                <QuestionPreviewTel
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTel>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.EMAIL">
              <div style="position: relative">
                <QuestionPreviewEmail
                  :params="{ data: item, index: index }"
                ></QuestionPreviewEmail>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DATE">
              <div style="position: relative">
                <QuestionPreviewDate
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDate>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TIME">
              <div style="position: relative">
                <QuestionPreviewTime
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTime>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ADDR">
              <div style="position: relative">
                <QuestionPreviewAddress
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAddress>
                <div class="mask-div"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.REMARK">
              <div style="position: relative">
                <QuestionPreviewRemark
                  :params="{ data: item, index: index }"
                ></QuestionPreviewRemark>
                <div class="mask-div"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="za-footer">
      <el-button type="primary" @click="handleSaveClick"> 确认录入 </el-button>
    </div>
    <ExampleDialog
      :showDialog="showDialog"
      :type="dialogType"
      @close="showDialog = false"
    ></ExampleDialog>
    <input
      type="file"
      ref="fileInput"
      accept=".xlsx,.docx"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import {
  convertQuestion,
  addQuestionsToBank,
  userLibraryList,
} from "@/api/index.js";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import ExampleDialog from "@/components/ExampleDialog/index.vue";
import { PreviewComponents } from "@/utils/componentImports.js";

export default {
  components: {
    ExampleDialog,
    ...PreviewComponents,
  },
  data() {
    return {
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      value: "",
      myLibraryList: [
        {
          label: "题库1",
          value: "1",
        },
        {
          label: "题库2",
          value: "2",
        },
      ],
      downloadOptions: [
        {
          label: "Excel下载",
          name: "Excel模板.xlsx",
          value:
            "https://ossfastmake.mustke.com/EvVnp3VEBERTBRPG/J26OWPfxYpSuUFuw/OTGw4XPrF1Sx13002f13047e184e13fccb431fc245aa-1754642710132.xlsx",
        },
        {
          label: "Word下载",
          name: "Word模板.docx",
          value:
            "https://ossfastmake.mustke.com/EvVnp3VEBERTBRPG/J26OWPfxYpSuUFuw/xtl2oeqBzGF3f88829c7a0c3e25f69f5f711dc8694ab-1754642748662.docx",
        },
      ],
      showDialog: false,
      dialogType: 1,
      downloadValue: "下载模板",
      extractedText: "",
      questionList: [],
      libraryName: "",
      libraryType: "", // 1 问卷 2 考试
      libraryId: null,
      loading: null,
    };
  },
  created() {},
  mounted() {
    this.getUserLibraryList();
  },
  methods: {
    handleShowDialog(type) {
      this.dialogType = type;
      this.showDialog = true;
    },
    handleSelectChange(event, type) {
      if (type === 1) {
        this.libraryType = event.libraryType;
        this.libraryId = event.value + "";
      } else {
        this.downloadValue = "下载模板";
        const x = new XMLHttpRequest();
        x.open("GET", event.value, true);
        x.responseType = "blob";
        x.onload = function () {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement("a");
          a.href = url;
          a.download = event.name;
          a.click();
        };
        x.send();
      }
    },
    handleUploadClick() {
      console.log(
        "12ei12rj2190r21r12ry12ry21r12",
        this.$store.getters.getAppId,
      );

      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      axios
        .post(baseURL + "/PCwj/userLibraryType/importFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log(response, "weewqe312312312312");
          if (response.data.code === 200) {
            // this.handleCheck();
            convertQuestion({
              libraryType: "1",
              title: response.data.data.extractedText,
            }).then((res) => {
              console.log(res, "检查结果");
              if (res.code === 200) {
                if (res.data.length === 0) {
                  this.$message.error("文档格式不正确");
                } else {
                  this.questionList = res.data;
                  this.extractedText = response.data.data.extractedText;
                }
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch((error) => {});
    },
    handleCheck() {
      convertQuestion({
        libraryType: "1",
        title: this.extractedText,
      }).then((res) => {
        console.log(res, "检查结果");
        if (res.code === 200) {
          this.questionList = res.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    saveQuestionClick(e) {
      console.log("saveQuestionClick", e);
    },
    updateQuestionClick() {
      console.log("updateQuestionClick");
    },
    cancelQuestionClick(e) {
      console.log("cancelQuestionClick", e);
    },
    handleOperateClick(e) {
      console.log("handleOperateClick", e);
    },
    handleSaveClick() {
      console.log("handleSaveClick");
      if (this.libraryName === "") {
        this.$message.error("请选择题库");
        return;
      }
      if (this.questionList.length === 0) {
        this.$message.error("请添加题目");
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      addQuestionsToBank({
        libraryType: this.libraryType,
        id: this.libraryId,
        yzUserQuestionPoolList: this.questionList,
      }).then((res) => {
        console.log(res, "确认录入");
        if (res.code === 200) {
          this.$message.success("确认录入成功");
          this.$router.push({
            path: "/libraryList",
            query: {
              id: this.libraryId,
            },
          });
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading.close();
      });
    },
    getUserLibraryList() {
      userLibraryList({
        libraryType: this.libraryType,
      })
        .then((res) => {
          console.log("==============99999", res);
          if (res.code === 200) {
            this.myLibraryList = res.data.map((item) => {
              return {
                label: item.libraryName,
                value: item.id,
                libraryType: item.libraryType,
              };
            });
            this.libraryId = this.myLibraryList[0].value;
            this.libraryName = this.myLibraryList[0].label;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.big-container {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  /* margin-top: 35px; */
  background-color: #fff;
  border-radius: 6px;
}

.zh-btn {
  width: 50px;
  height: 50px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 26px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: Semibold;
  color: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
}

.zh-container {
  display: flex;
  align-items: center;
  height: calc(100% - 42px - 10px - 50px);
  margin-top: 10px;
}

.zh-container-left {
  flex: 1;
  height: 100%;
  background: #f9f9f9;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  padding: 10px;
  box-sizing: border-box;
}

.zh-container-right {
  flex: 1;
  height: 100%;
  background: #f9f9f9;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  padding: 10px;
  box-sizing: border-box;
}

.zh-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.zh-header-left {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.zh-header-right {
  display: flex;
  align-items: center;
}

.hover-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  width: 143px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 3px;
  font-size: 14px;
  /* font-family: PingFang SC, PingFang SC-Regular; */
  font-weight: 400;
  text-align: left;
  /* color: #606266; */
  margin-left: 10px;
  cursor: pointer;
}

.hover-content p {
  color: #606266;
  font-weight: 400;
}

.question-list-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.question-item {
  margin-bottom: 10px;
}

.za-footer {
  width: 100%;
  text-align: right;
  margin-top: 10px;
}

.el-input__inner {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/LibraryEntry/index.vue